<template>
 <v-dialog v-model="dialogWebviewbig" width="500" persistent style="overflow-y: hidden;border-radius:20px;">
  <v-card style="border-radius:20px;">
  <v-card tile>
      <v-toolbar card style="background: #1a222c !important;">
        <v-toolbar-title class="white--text CSChatThai">&nbsp;&nbsp;{{Webview_item.label}} </v-toolbar-title>
        <v-spacer></v-spacer>
          <v-btn dark icon flat @click.native="newtab">
            <v-icon style="color: white !important; font-size: 20px !important;">far fa-window-restore</v-icon>
          </v-btn>
        <v-btn dark icon flat @click.native="closeDialog">
          <v-icon style="color: white !important; font-size: 20px !important;">clear</v-icon>
        </v-btn>
      </v-toolbar>
    </v-card>
  <v-card-text  style="padding: 0; height: 550px !important;">

    <!-- weeerr -->
     <iframe width="500" height="550" style="visibility:visible;" frameborder='0' allowfullscreen :src="Webview_item.url" allow="geolocation;clipboard-read; clipboard-write" v-if="!progressLoding"></iframe>
<!-- <iframe width="500" height="550" style="visibility:visible;" frameborder='0' src="https://etaxgateway.one.th/webfooddelivery?authorize=3045279722" allow="geolocation"></iframe>
 -->
    <v-layout wrap v-else>
      <v-flex sm12 md12 lg12 xl12 style="justify-content: center; display: grid;height: 80vh;">
        <div style="margin: auto;">
          <h3 style="text-align: center;">กรุณารอซักครู่ ระบบกำลังประมวลผล</h3>
        </div>
      </v-flex>
    </v-layout>




</v-card-text>
</v-card>
</v-dialog>
</template>
<script>
import { sync } from 'vuex-pathify'
export default {
  props: {
    dialogWebviewbig: false,
    Webview_item: {},
    tokenrooomSelect: String,
    token: String
  },
  data () {
    return {
      progressLoding: true
    }
  },
  watch: {
    socket_close_webview () {
      this.closeDialog()
    },
    Webview_item () {
      if (this.Webview_item.url) {
        this.progressLoding = false
      }
    }
  },
  computed: {
    ...sync('*')
  },
  methods: {
    closeDialog () {
      this.$emit('closeWebview', false)
      this.progressLoding = true
      this.closewebview()
    },
    newtab () {
      // this.Webview_item.url
      window.open(this.Webview_item.url, '_blank')
      this.closeDialog()
    },
    closewebview () {
      // console.log(authen.tokenuser)
      this.axios.post(process.env.APIalpine + `/api/v1/close-webview`, {
        tokenroom: this.tokenrooomSelect,
        tokenuser: this.token
      }).then((response) => {
        // console.log(response.data)
      }).catch(error => {
        console.log(error)
      })
    }
  }
}
</script>
<style type="text/css" scoped>
/* .iframe-container{
     width:100%;
     min-height:200px;
     max-height:100vh;
} */

/* .iframe-container iframe{
     width:100%;
     height:100%;
     object-fit:contain;
} */
</style>



// WEBPACK FOOTER //
// src/components/chat/dialog/manage_chat/WebviewBigDialog.vue